import { NgModule }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';

import { DashboardComponent }   from './dashboard.component';
import { FooterComponent }   from '../footer/footer.component';
import { AngularMaterialModule } from '../angular-material.module';
import { VehiclesModule } from '../vehicles/veh.module';
import { InspectionsModule } from '../inspection/insp.module';

@NgModule({
  imports:      [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    VehiclesModule,
    InspectionsModule
  ],
  providers:    [ 
  ],
  declarations: [
    DashboardComponent,
    FooterComponent
  ],
  exports:      [ DashboardComponent ]
})
export class DashboardModule { }
